"use strict";
/**
 * index.js
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var hmac = __importStar(require("./hmac"));
exports.compute = hmac.compute;
exports.verify = hmac.verify;
exports.default = { compute: exports.compute, verify: exports.verify };
//# sourceMappingURL=index.js.map